import { Injectable, Inject, InjectionToken } from '@angular/core';
import EstensaModel from 'estensa-module';
import { constant } from 'lodash-es';
import { from } from 'rxjs';

export const ESTENSA_MODULE_PATIENT_SERVICE = new InjectionToken('estensa.module.patient.service');

interface IPatientServiceNg1 {
    getPatient(patientId: string, displayNgLoadingSpinner: boolean): { $promise: Promise<EstensaModel.Patient> };
}

@Injectable()
export class NullPatientService implements IPatientServiceNg1 {
    getPatient = constant({ $promise: Promise.resolve(null) });
}

@Injectable({
    providedIn: 'root',
})
export class EstensaPatientService {
    constructor(@Inject(ESTENSA_MODULE_PATIENT_SERVICE) private patientService: IPatientServiceNg1) {}

    getPatient(patientId: string, displayNgLoadingSpinner: boolean = true) {
        return from(this.patientService.getPatient(patientId, displayNgLoadingSpinner).$promise);
    }
}
